var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty-hint-container"},[_vm._v(" "+_vm._s(_vm.$t('目前尚無任何內容'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }